import BreakingNews from "../../components/BreakingNews";
import NewsCard from "../../components/NewsCard";
import WebStories from "../../components/WebStories.jsx";
import { latestStories, sidebarAd } from "./sidebarData.js";
import { topNews2, topNews, mpNews, videonews, webStories } from "./homeData.js";
import { useEffect, useState } from "react";
import axios from "axios";


import ViewAllHeader from "../../common/ViewAllHeader";
import LatestStories from "../../components/LatestStories";


const Home = () => {

  useEffect(() => {
    console.log("window.scrollY =", window.scrollY);
    const left = document.querySelector(".left");
    console.log("left.scrollTop =", left?.scrollTop);
  }, []);

  const [latestNews, setLatestNews] = useState([]);
  const [newsRotationIndex, setNewsRotationIndex] = useState(0);
  const latestStoriesDynamic = latestNews.slice(0, 4);
  const [videos, setVideos] = useState([]);
  const [adItem, setAdItem] = useState(null);
  const [adItems, setAdItems] = useState([]);
  const [adIndex, setAdIndex] = useState(0);
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}media`
        );

        // latest 2 videos only
        setVideos(res.data.slice(0, 2));
      } catch (err) {
        console.error("Failed to fetch videos", err);
      }
    };

    fetchVideos();
  }, []);

  useEffect(() => {
    const fetchLatestNews = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}product`
        );

        // newest first, only 8
        setLatestNews(res.data.slice(0, 8));
      } catch (err) {
        console.error("Failed to fetch latest news", err);
      }
    };

    fetchLatestNews();
  }, []);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}message`
        );
        const ads = res.data || [];
        setAdItems(ads);
        if (ads.length) {
          const baseUrl = process.env.REACT_APP_BACKEND_URL.replace(
            "/api/v1/",
            ""
          );
          const first = ads[0];
          setAdItem({
            image: first.image
              ? `${baseUrl}/uploads/messages/${first.image}`
              : sidebarAd.image,
            alt: first.name || sidebarAd.alt,
            link: "/ad",
          });
        } else {
          setAdItem(null);
        }
      } catch (err) {
        console.error("Failed to fetch ads", err);
        setAdItems([]);
        setAdItem(null);
      }
    };

    fetchAds();
  }, []);

  useEffect(() => {
    if (adItems.length <= 1) return;
    const intervalId = setInterval(() => {
      setAdIndex((prev) => (prev + 1) % adItems.length);
    }, 8000);
    return () => clearInterval(intervalId);
  }, [adItems.length]);

  useEffect(() => {
    if (!adItems.length) return;
    const baseUrl = process.env.REACT_APP_BACKEND_URL.replace(
      "/api/v1/",
      ""
    );
    const current = adItems[adIndex];
    setAdItem({
      image: current.image
        ? `${baseUrl}/uploads/messages/${current.image}`
        : sidebarAd.image,
      alt: current.name || sidebarAd.alt,
      link: "/ad",
    });
  }, [adItems, adIndex]);

  useEffect(() => {
    if (latestNews.length <= 1) return;
    const intervalId = setInterval(() => {
      setNewsRotationIndex((prev) => (prev + 1) % latestNews.length);
    }, 10000);
    return () => clearInterval(intervalId);
  }, [latestNews.length]);

  const rotateNews = (items, startIndex) => {
    if (!items.length) return items;
    const safeIndex = startIndex % items.length;
    return [...items.slice(safeIndex), ...items.slice(0, safeIndex)];
  };
  const latestNewsRotated = rotateNews(latestNews, newsRotationIndex);
  console.log("ALL STATES =", latestNews.map(n => n.state));
  const mpNewsDynamic = latestNewsRotated.filter(
    (item) => item.state?.toLowerCase() === "madhyapradesh"
  );


  const deshDuniyaNewsDynamic = latestNewsRotated.filter(
    (item) => item.state?.toLowerCase() !== "madhyapradesh"
  );
  const getEmbedUrl = (url) => {
    if (!url) return "";

    // youtu.be/xxxx
    if (url.includes("youtu.be")) {
      const id = url.split("youtu.be/")[1];
      return `https://www.youtube.com/embed/${id}`;
    }

    // youtube.com/watch?v=xxxx
    if (url.includes("watch?v=")) {
      const id = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${id}`;
    }

    return url;
  };


  return (
    // <div className="max-w-7xl mx-auto -mt-[65px] px-4 py-6 sm:mt-[0px]">
    <div className="max-w-7xl mx-auto px-4 py-6">


      {/* BREAKING NEWS */}
      <BreakingNews />

      <div className="mt-2 grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* ================= LEFT SIDE ================= */}
        <div className="lg:col-span-9 space-y-12">
<WebStories/>
          {/* 🔹 TOP NEWS */}
          <section>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* {topNews2.slice(0, 2).map((item, i) => (
                <NewsCard key={i} {...item} />
              ))} */}
              {latestNewsRotated.slice(0, 2).map((item) => (
                <NewsCard
                  key={item.id}
                  title={item.news_title}
                  image={`${process.env.REACT_APP_BACKEND_URL.replace(
                    "/api/v1/",
                    ""
                  )}/uploads/news/${item.thumbnail}`}
                  category={item.category}
                  date={item.createdAt}
                  fullNews={item.description}
                  author={item.reporter_name}
                  reporter_image={
                    item.reporter_image
                      ? `${process.env.REACT_APP_BACKEND_URL.replace(
                        "/api/v1/",
                        ""
                      )}/uploads/news/${item.reporter_image}`
                      : null
                  }
                  readTime="2 Min Read"
                  videoUrl={item.youtube_url}
                  link={`/news/${item.id}`}
                />
              ))}

            </div>
          </section>
          <section>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* {topNews.slice(0, 12).map((item, i) => (
                <NewsCard key={i} {...item} />
              ))} */}
              {latestNewsRotated.slice(2, 8).map((item) => (
                <NewsCard
                  key={item.id}
                  title={item.news_title}
                  image={`${process.env.REACT_APP_BACKEND_URL.replace(
                    "/api/v1/",
                    ""
                  )}/uploads/news/${item.thumbnail}`}
                  category={item.category}
                  description={item.description}
                  date={item.createdAt}
                  fullNews={item.description}
                  author={item.reporter_name}
                  reporter_image={
                    item.reporter_image
                      ? `${process.env.REACT_APP_BACKEND_URL.replace(
                        "/api/v1/",
                        ""
                      )}/uploads/news/${item.reporter_image}`
                      : null
                  }
                  readTime="2 Min Read"
                  link={`/news/${item.id}`}
                  videoUrl={item.youtube_url}
                />
              ))}


            </div>
          </section>

          {/* 🔹 MP TOP NEWS */}
          <section>
            <ViewAllHeader title="मध्य प्रदेश" to="/mp" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {mpNewsDynamic.slice(0, mpNews.length).map((item) => (
                <NewsCard
                  key={item.id}
                  title={item.news_title}
                  image={`${process.env.REACT_APP_BACKEND_URL.replace(
                    "/api/v1/",
                    ""
                  )}/uploads/news/${item.thumbnail}`}
                  category={item.category}
                  description={item.description}
                  date={item.createdAt}
                  fullNews={item.description}
                  author={item.reporter_name}
                  reporter_image={
                    item.reporter_image
                      ? `${process.env.REACT_APP_BACKEND_URL.replace(
                        "/api/v1/",
                        ""
                      )}/uploads/news/${item.reporter_image}`
                      : null
                  }
                  readTime="2 Min Read"
                  link={`/news/${item.id}`}
                  videoUrl={item.youtube_url}
                />
              ))}


            </div>
          </section>

          {/* 🔹 VIDEO SECTION (same card, videoUrl present) */}
          {/* <section>
            <h2 className="text-xl font-bold mb-4 border-b pb-2 text-red-600">
              वीडियो
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {videonews
                .filter(item => item.videoUrl)
                .slice(0, 2)
                .map((item, i) => (
                  <NewsCard key={i} {...item} />
                ))}
            </div>
          </section> */}
          <section>
            <ViewAllHeader title="वीडियो" to="/gallery/videos" />


            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {videos.map((video) => (
                <iframe
                  key={video.id}
                  className="w-full h-[300px] rounded"
                  src={getEmbedUrl(video.url)}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ))}
            </div>
          </section>


          {/* 🔹 MORE CATEGORY BLOCK (example) */}
          <section>
            <ViewAllHeader title="देश – दुनिया" to="/world" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {deshDuniyaNewsDynamic.slice(0, 3).map((item) => (
                <NewsCard
                  key={item.id}
                  title={item.news_title}
                  image={`${process.env.REACT_APP_BACKEND_URL.replace(
                    "/api/v1/",
                    ""
                  )}/uploads/news/${item.thumbnail}`}
                  category={item.category}
                  description={item.description}
                  date={item.createdAt}
                  link={`/news/${item.id}`}  
                  videoUrl={item.youtube_url}
                />
              ))}

            </div>
          </section>
        </div>
        {/* ================= RIGHT SIDE ================= */}
        <aside className="lg:col-span-3">
          <div className="sticky top-[120px] space-y-4">
            <LatestStories />
            <div className="bg-white rounded-lg border shadow-sm overflow-hidden p-1">
              <a
                href={(adItem || sidebarAd).link || "/ad"}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <img
                  src={(adItem || sidebarAd).image}
                  alt={(adItem || sidebarAd).alt}
                  className="w-full h-full object-contain bg-white rounded hover:opacity-95 transition"
                />
              </a>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Home;
